module.exports = __webpack_public_path__ + "static/media/cart_plus_fill_icon.66122812.svg";